import LoginRegister from '@sectionsJS/account/login-register';

document.addEventListener('DOMContentLoaded', () => {
  new LoginRegister();
});
